const getFileBase64 = file => new Promise((resolve, reject) => {
  const fileReader = new FileReader();

  fileReader.onload = () => {
    resolve(fileReader.result);
  };

  fileReader.onerror = () => {
    reject(fileReader.error || new Error('Unable to read the selected file'));
  };

  fileReader.onabort = () => {
    reject(new Error('Reading the selected file was cancelled'));
  };

  fileReader.readAsDataURL(file);
});

export default getFileBase64;
